import * as React from 'react';

import Blockquote from 'components/Blockquote';
import useLiveData from 'hooks/useLiveData';
import { useStaticQuery, graphql } from 'gatsby';

const BlockquoteProvider = (props) => {
	const data = useStaticQuery(graphql`
		query blockQuotes {
		  allSmartTagsBlockquote {
		    edges {
		      node {
		        id
		        flush
				background
				backgroundImage
				backgroundProps
				padding
		        illustration
				quote
		        source
		      }
		    }
		  }
		}
	`);
	const {response} = useLiveData({
		namespace: 'SmartTags',
		model: 'Blockquote',
		method: 'all',
		staticData: data,
		graphqlKey: 'allSmartTagsBlockquote',
	});
	if (response.data.length === 0)return null;
	let attr;
	for (let item of response.data) {
		if (item.id === props.id)attr = item;
	}
	if (!attr)return null;
	return <Blockquote {...attr} />
}

export default BlockquoteProvider;